<template>
  <div>
    <v-dialog v-if="pDataPass.isVisibleLoad" v-model="dLoadingCharge" hide-overlay persistent width="300">
      <v-card class="datModalTitleContainer" dark>
        <v-card-text>
          {{ $t('cargandoContenido') }}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-layout row wrap>
      <v-flex xs12 sm3>
        <v-text-field clearable id="codUserDat" ref="codUserDat" color="datPrimary" class="pr-1" name="code"
          :disabled="dDisabledInput" :label="$t(pDataPass.labelMainField)" v-model="dSelected.codigo"
          @click:append="fAbreBuscador" @change="fSeleccionaElemento" @click:clear="fClear"></v-text-field>
      </v-flex>
      <v-flex xs12 sm2>
        <v-text-field color="datPrimary" id="agentUserDat" ref="agentUserDat" class="pr-1" name="code"
          :label="$t(pDataPass.labelSubfield)" v-model="dSelected.subfield" :disabled="true"
          @click:append="fAbreBuscador" @change="fSeleccionaElemento"></v-text-field>
      </v-flex>

      <v-flex xs12 sm7>
        <v-text-field clearable id="nameUserDat" ref="nameUserDat" color="datPrimary" class="pl-1"
          :error-messages="dErrorMessagesComponente" :name="$t(pDataPass.label)" :disabled="dDisabledInput"
          :required="pDataPass.required" :label="$t(pDataPass.label)" v-model="dSelected.nombre"
          append-icon="mdi-text-search" @click:append="fAbreBuscador" @change="fSeleccionaElemento"></v-text-field>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dDataTable.isVisible" max-width="500px">
      <v-toolbar dark class="primaryColorBackground">
        <v-toolbar-title>{{ $t(pDataPass.title) }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="fCloseDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <data-new-table ref="TablaInterna" :pData="dDataTable" @recharge="fCargaEvent"
        @selectItem="fSelectItem"></data-new-table>
    </v-dialog>
  </div>
</template>

<script>

import SrvGeneral from '@/services/srv-general'
import DataNewTable from '@/components_datadec/DataNewTable'

export default {
  components: {
    DataNewTable
  },
  props: {
    pDataPass: {
      type: Object,
      default: {
        'labelMainField': '',
        'labelSubField': '',
        'errorMessages': [],
        'label': '',
        'rowsPerPage': 0,
        'headers': [],
        'urlWS': '',
        'urlSec': '',
        'headersSec': [],
        'filtersSec': {},
        'defaultSec': {},
        'isSec': false,
        'requestSec': {},
        'orderByDefaultSec': '',
        'item': {
          'codigo': '',
          'subfield': '',
          'nombre': ''
        },
        'filters': {},
        'request': {},
        'default': {},
        'disabled': false,
        'required': false,
        'isVisibleLoad': false,
        'orderByDefault': '',
        'orderDefault': ''
      }
    }
  },
  data() {
    return {
      dErrorMessagesComponente: [],
      dLoadingText: false,
      dDisabledInput: false,
      dShowDialog: false,
      dSelected: { codigo: '', subfield: '', nombre: '' },
      dItems: [],
      dItemsAux: [],
      dTotalItems: 0,
      dActivaBusqueda: false,
      dTextoSeleccionado: '',
      dLoadingCharge: false,
      dDataTable: {}
    }
  },
  watch: {
    'pDataPass.default': {
      handler() {
        this.dSelected = this.pDataPass.default ? {
          codigo: this.pDataPass.default.codigo,
          subfield: this.pDataPass.default.subfield,
          nombre: this.pDataPass.default.nombre
        } : {
          codigo: '',
          subfield: '',
          nombre: ''
        }
      }
    },
    'pDatapass.disabled': {
      handler() {
        this.dDisabledInput = this.pDataPass.disabled
      }
    },
    'pDatapass.errorMessages': {
      handler() {
        this.dErrorMessagesComponente = this.pDataPass.errorMessages
      }
    },
    /**
     * Comprueba si el valor es numerico
     */
    'dSelected.codigo': function (val, oldVal) {
      if ((this.dSelected.codigo === '') || (this.dSelected.codigo === undefined)) {
        this.dSelected.nombre = ''
        this.dSelected.subfield = ''
        this.dErrorMessagesComponente = []
        const obj = {}
        obj[this.pDataPass.item.codigo] = ''
        obj[this.pDataPass.item.subfield] = ''
        obj[this.pDataPass.item.nombre] = ''
        this.$emit('select', obj)
        this.$emit('change', '')
      }
    },
    /**
     * Comprueba si el valor es numerico
     */
    'dSelected.nombre': function (val, oldVal) {
      if ((this.dSelected.nombre === '') || (this.dSelected.nombre === undefined)) {
        this.dSelected.codigo = ''
        this.dSelected.subfield = ''
        this.dErrorMessagesComponente = []
        const obj = { codigo: '', subfield: '', nombre: '' }
        this.$emit('select', obj)
        this.$emit('change', '')
      }
    }
  },
  created() {
    this.fIniciarVariables()
    // Selecciona el elemento pode defecto
    this.dSelected = this.pDataPass.default ? {
      codigo: this.pDataPass.default.codigo,
      subfield: this.pDataPass.default.subfield,
      nombre: this.pDataPass.default.nombre
    } : {}
  },
  methods: {

    fIniciarVariables() {
      const headersPass = (this.pDataPass.isSec) ? this.pDataPass.headersSec : this.pDataPass.headers
      const orderByDefault = (this.pDataPass.isSec) ? this.pDataPass.orderByDefault : this.pDataPass.orderByDefaultSec
      const orderDefault = this.pDataPass.orderDefault
      this.dDataTable = {
        'headers': headersPass,
        'items': [],
        'initSearch': '',
        'totalItems': 0,
        'checkboxOn': false,
        'rowsPerPage': this.pDataPass.rowsPerPage,
        'loading': false,
        'isVisible': false,
        'descending': orderDefault !== 'ASC',
        'sortBy': orderByDefault,
        'page': 1
      }
      this.dDisabledInput = this.pDataPass.disabled
      this.dErrorMessagesComponente = this.pDataPass.errorMessages
    },
    fCargaEvent(parametros) {
      this.fCargaDatos(parametros.sortBy, parametros.descending, parametros.page, parametros.rowsPerPage, parametros.search, parametros.filters)
    },
    fCloseDialog() {
      this.dDataTable.isVisible = false
      this.$refs.TablaInterna.fResetPage()
    },
    fSelectItem(item) {
      this.dSelected = item
      this.dDataTable.isVisible = false
      // Emite el reseteo de la página de la tabla
      this.$refs.TablaInterna.fResetPage()
      // emite el evento hacia el llamador
      this.$emit('select', this.dSelected)
      this.$emit('change', '')
    },
    fSeleccionaElemento(event) {
      this.dActivaBusqueda = true
      const descending = this.pDataPass.orderDefault !== 'ASC'
      if ((this.dSelected.codigo !== '') || (this.dSelected.nombre !== '')) {
        if ((this.dSelected.codigo === '') || (this.dSelected.codigo === undefined)) {
          this.dDataTable.initSearch = this.dSelected.nombre
          this.fCargaDatos(this.pDataPass.orderByDefault, descending, 1, 5, this.dSelected.nombre, [])
        } else {
          this.dDataTable.initSearch = (this.dSelected.codigo && this.dSelected.codigo !== null) ? this.dSelected.codigo.toString() : ''
          this.fCargaDatos(this.pDataPass.orderByDefault, descending, 1, 5, this.dSelected.codigo, [])
        }
      }
    },
    fActualizarItem(item) {
      this.dSelected = item
    },
    fAbreBuscador() {
      this.dActivaBusqueda = true
      this.dSelected = { 'codigo': '', 'subfield': '', 'nombre': '' }
      const descending = this.pDataPass.orderDefault !== 'ASC'
      if ((this.dSelected.codigo === '') || (this.dSelected.codigo === undefined)) {
        this.dDataTable.initSearch = this.dSelected.nombre
        this.fCargaDatos(this.pDataPass.orderByDefault, descending, 1, this.pDataPass.rowsPerPage, this.dSelected.nombre, [])
      } else {
        this.dDataTable.initSearch = (this.dSelected.codigo !== undefined) ? this.dSelected.codigo.toString() : ''
        this.fCargaDatos(this.pDataPass.orderByDefault, descending, 1, this.pDataPass.rowsPerPage, this.dSelected.codigo, [])
      }
    },
    fClear() {
      this.dSelected = { 'codigo': '', 'subfield': '', 'nombre': '' }
      this.$emit('clean')
    },
    fGetColumna(sortBy) {
      const headersPass = (this.pDataPass.isSec) ? this.pDataPass.headersSec : this.pDataPass.headers
      if (headersPass) {
        if (headersPass.length > 0) {
          for (let i = 0; i < headersPass.length; i++) {
            const header = headersPass[i]
            if (header.value === sortBy) {
              return header.column
            }
          }
        }
      }
      return this.pDataPass.orderByDefault
    },
    fAssignedItems(response) {
      this.dDataTable.items = []
      const filtersPass = (this.pDataPass.isSec) ? this.pDataPass.filtersSec : this.pDataPass.filters
      if (response.data[this.pDataPass.resultName].length > 1) {
        this.dDataTable.items = response.data[this.pDataPass.resultName].map((item) => {
          return {
            codigo: item[filtersPass.codigo],
            subfield: item[filtersPass.subfield],
            nombre: item[filtersPass.nombre]
          }
        })
        this.dDataTable.totalItems = response.data.numReg
        if (this.pDataPass.isVisibleLoad) {
          this.dLoadingCharge = false
        }
        if (this.dActivaBusqueda) {
          this.dDataTable.isVisible = true
        }
        this.dActivaBusqueda = false
      } else if (response.data[this.pDataPass.resultName].length === 1) {
        this.dDataTable.items = response.data[this.pDataPass.resultName].map((item) => {
          return {
            codigo: item[filtersPass.codigo],
            subfield: item[filtersPass.subfield],
            nombre: item[filtersPass.nombre]
          }
        })
        this.dSelected = {
          codigo: response.data[this.pDataPass.resultName][0][filtersPass.codigo],
          subfield: response.data[this.pDataPass.resultName][0][filtersPass.subfield],
          nombre: response.data[this.pDataPass.resultName][0][filtersPass.nombre]
        }
        this.$emit('select', this.dSelected)
        this.$emit('change', '')
        if (this.pDataPass.isVisibleLoad) {
          this.dLoadingCharge = false
        }
      } else {
        this.dErrorMessagesComponente = [this.$t('noExisteElemento')]
        this.$refs.nameUserDat.clearableCallback()
        this.$refs.agentUserDat.clearableCallback()
        this.$emit('change', this.dErrorMessagesComponente)
        if (this.pDataPass.isVisibleLoad) {
          this.dLoadingCharge = false
        }
      }
      this.dLoadingText = false
    },
    fCargaDatos(sortBy, descending, page, rowsPerPage, search, filters, byCodigo) {
      this.dErrorMessagesComponente = []
      this.$emit('search')
      this.dLoadingText = true
      let offset = 1
      let urlPass = ''
      let request = ''
      let jsonEntrada = ''
      let searchCols = ''

      if (this.pDataPass.isVisibleLoad) {
        this.dLoadingCharge = true
      }

      descending = (descending) ? 'DESC' : 'ASC'
      page = (page === undefined) ? 1 : page
      rowsPerPage = (rowsPerPage === undefined) ? this.pDataPass.rowsPerPage : rowsPerPage
      search = (search === null) ? '' : search
      offset = this.pDataPass.rowsPerPage * (page - 1) + 1

      // SE CAMBIAN LOS DATOS EN FUNCIÓN DE SI ES UNA EJECUCIÓN DEL WS SECUNDARIO

      if (this.pDataPass.isSec) {
        urlPass = this.pDataPass.urlSec
        request = this.pDataPass.requestSec
        filters = this.pDataPass.filtersSec
        searchCols = '' + filters.codigo + ',' + filters.nombre + ''
        sortBy = this.pDataPass.orderByDefaultSec
        jsonEntrada = {
          tira: this.$store.getters.getAutenticacion.tira,
          offset: offset,
          numRows: rowsPerPage,
          search: search,
          searchCols: searchCols,
          orderBy: sortBy,
          order: descending,
          representante: this.pDataPass.requestSec.representante,
          empresa: this.pDataPass.requestSec.empresa,
          agente: this.pDataPass.requestSec.agente
        }
      } else {
        urlPass = this.pDataPass.urlWS
        request = this.pDataPass.request
        filters = this.pDataPass.filters
        searchCols = '' + filters.codigo + ',' + filters.nombre + ''
        sortBy = (sortBy === undefined) ? this.pDataPass.orderByDefault : this.fGetColumna(sortBy)
        jsonEntrada = {
          tira: this.$store.getters.getAutenticacion.tira,
          offset: offset,
          numRows: rowsPerPage,
          search: search,
          searchCols: searchCols,
          orderBy: sortBy,
          order: descending
        }
      }

      // prepara los parametros generales de busqueda

      if ((this.dSelected.codigo !== '') && (this.dSelected.codigo !== undefined)) {
        jsonEntrada[filters.codigo] = search
      }

      // Añade los parametros propios de busqueda
      Object.assign(jsonEntrada, request)

      // lanza la peticion web service
      if (request) {
        // 
        if (!(SrvGeneral[urlPass] && typeof SrvGeneral[urlPass] === 'function')) {
          this.$emit('alert', `No se ha podido realizar la llamada a ${urlPass}`)
        }
        // 
        SrvGeneral[urlPass](jsonEntrada).then(response => {
          if (response.data.statusCode === '200') {
            this.fAssignedItems(response)
          } else {
            this.$emit('alert', '<b>' + this.pDataPass.resultName + '</b><br> ' + response.data.statusText + '  (' + response.data.statusCode + ' ) ')
            if (this.pDataPass.isVisibleLoad) {
              this.dLoadingCharge = false
            }
          }
        }).catch(error => {
          console.log(error)
          this.$emit('alert', '<b>' + this.pDataPass.resultName + '</b><br> ' + error.response.data.statusText)
          if (this.pDataPass.isVisibleLoad) {
            this.dLoadingCharge = false
          }
        })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components_datadec/DatTextFieldCodeSubfield.vue